import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AUTH_REQUIRED_EVENT } from '../auth/constants';
import { REQUIRE_EDITOR_LOGIN } from '../config';
import { openModal } from '../redux/reducers/global/modal/modalSlice';

const getSafeLocation = () => {
  if (typeof window === 'undefined' || !window.location) {
    return '/';
  }
  return window.location.href;
};

export default function useAuthRequiredListener() {
  const dispatch = useDispatch();
  const isLoginModalOpen = useSelector(
    (state) => state.modal.isOpen && state.modal.modalType === 'AUTH_LOGIN'
  );
  const suppressNext = useRef(false);

  useEffect(() => {
    suppressNext.current = isLoginModalOpen;
  }, [isLoginModalOpen]);

  useEffect(() => {
    if (!REQUIRE_EDITOR_LOGIN || typeof window === 'undefined') {
      return () => {};
    }

    const handler = (event) => {
      if (suppressNext.current) {
        return;
      }

      const detail = event?.detail || {};
      suppressNext.current = true;
      dispatch(
        openModal({
          modalType: 'AUTH_LOGIN',
          modalProps: {
            redirectUrl: detail.redirectUrl || getSafeLocation(),
            lastEndpoint: detail.endpoint,
            reason: detail.reason || detail.message,
          },
        })
      );
    };

    window.addEventListener(AUTH_REQUIRED_EVENT, handler);
    return () => window.removeEventListener(AUTH_REQUIRED_EVENT, handler);
  }, [dispatch]);
}
